module.exports = __webpack_public_path__ + "static/media/IUP_L1.e8aad30d.svg";